import type { ServiceCategory } from './types'

export const serviceCategories: readonly ServiceCategory[] = [
  {
    id: 'copy-print',
    name: 'Copy & Print',
    slug: 'copy-print',
    eyebrow: 'Professional document services',
    summary: 'Color and black-and-white copying, printing, design, and finishing services.',
  },
  {
    id: 'home-business',
    name: 'Home & Business',
    slug: 'home-business',
    eyebrow: 'Convenient business services',
    summary: 'Mailbox, document, notary, and related services for local customers.',
  },
  {
    id: 'shipping',
    name: 'Shipping',
    slug: 'shipping',
    eyebrow: 'Fast, professional shipping service',
    summary: 'Domestic and international shipping options from leading carriers.',
  },
  {
    id: 'packing',
    name: 'Packing',
    slug: 'packing',
    eyebrow: 'Professional packing help',
    summary: 'Packing solutions for everyday, fragile, valuable, and unusually shaped items.',
  },
]
